// extracted by mini-css-extract-plugin
module.exports = {"title":"header_title__37cLc","header":"header_header__1acUb"};